import React, { Children } from 'react';
import { TopNav } from '../components/layout/TopNav';
import { BottomNav } from '../components/layout/BottomNav';
import { CheckCircle2, Info } from 'lucide-react';
import { motion } from 'framer-motion';
export function WICEBTGuidePage() {
  return <div className="min-h-screen bg-[#FAF8F5] pb-24 md:pb-8" data-id="element-408">
      <TopNav data-id="element-409" />

      <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-410">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-411">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-412">
            WIC & EBT/SNAP Guide
          </h1>
          <p className="text-lg text-gray-600 mb-8" data-id="element-413">
            We proudly accept WIC and EBT/SNAP benefits. Here's everything you
            need to know.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8 mb-6" data-id="element-414">
          <div className="flex items-center gap-3 mb-4" data-id="element-415">
            <div className="bg-[#1e3a8a] p-2 rounded-lg" data-id="element-416">
              <CheckCircle2 className="w-6 h-6 text-white" data-id="element-417" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-418">WIC Program</h2>
          </div>
          <p className="text-gray-600 mb-4" data-id="element-419">
            The Special Supplemental Nutrition Program for Women, Infants, and
            Children (WIC) provides federal grants to states for supplemental
            foods, health care referrals, and nutrition education.
          </p>
          <div className="bg-[#1e3a8a]/5 rounded-xl p-4" data-id="element-420">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-421">
              WIC-Approved Items at El Shadaih International Market:
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-422">
              <li className="flex items-start gap-2" data-id="element-423">
                <CheckCircle2 className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" data-id="element-424" />
                <span data-id="element-425">Fufu Flour (Plantain & Cassava)</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-426">
                <CheckCircle2 className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" data-id="element-427" />
                <span data-id="element-428">Fresh fruits and vegetables</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-429">
                <CheckCircle2 className="w-5 h-5 text-[#1e3a8a] flex-shrink-0 mt-0.5" data-id="element-430" />
                <span data-id="element-431">Whole grains and cereals</span>
              </li>
            </ul>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8 mb-6" data-id="element-432">
          <div className="flex items-center gap-3 mb-4" data-id="element-433">
            <div className="bg-[#ff6b35] p-2 rounded-lg" data-id="element-434">
              <CheckCircle2 className="w-6 h-6 text-white" data-id="element-435" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-436">
              EBT/SNAP Benefits
            </h2>
          </div>
          <p className="text-gray-600 mb-4" data-id="element-437">
            The Supplemental Nutrition Assistance Program (SNAP) helps
            low-income individuals and families buy the food they need for good
            health.
          </p>
          <div className="bg-[#ff6b35]/5 rounded-xl p-4" data-id="element-438">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-439">
              How to Use EBT at Our Store:
            </h3>
            <ol className="space-y-2 text-gray-700 list-decimal list-inside" data-id="element-440">
              <li data-id="element-441">Shop for eligible items (look for the EBT badge)</li>
              <li data-id="element-442">Present your EBT card at checkout</li>
              <li data-id="element-443">Enter your PIN when prompted</li>
              <li data-id="element-444">Your benefits will be automatically deducted</li>
            </ol>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-gradient-to-br from-[#ff6b35]/10 to-[#1e3a8a]/10 rounded-2xl border border-[#ff6b35]/20 p-6 md:p-8" data-id="element-445">
          <div className="flex items-start gap-3" data-id="element-446">
            <Info className="w-6 h-6 text-[#ff6b35] flex-shrink-0 mt-1" data-id="element-447" />
            <div data-id="element-448">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-449">Need Help?</h3>
              <p className="text-gray-700 mb-3" data-id="element-450">
                Our staff is trained to assist with WIC and EBT transactions.
                Don't hesitate to ask if you have questions about eligible items
                or how to use your benefits.
              </p>
              <a href="tel:4432742094" className="inline-flex items-center gap-2 bg-[#ff6b35] text-white font-semibold px-4 py-2 rounded-lg hover:bg-[#e85a2a] transition-colors" data-id="element-451">
                Call Us: (443) 274-2094
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      <BottomNav data-id="element-452" />
    </div>;
}